import React, { Component, Fragment } from 'react';
import {
  CloseCircleFilled,
  CloseOutlined,
  DeleteOutlined,
  SearchOutlined,
} from '@ant-design/icons';
import { Select, Input, Popover, Tooltip } from "antd";
import { strDelimited } from '../../../../services/helper/split';
import { SPICE } from '../../../../services/Cascade/constants';
import _ from 'lodash';

const PMIC = 'PMIC', IC = 'IC'
class Model extends Component {
  constructor(props) {
    super(props);
    this.state = {
      maxHeight: 300
    }
  }

  componentDidMount() {
    if (this.props.onRef) {
      this.props.onRef(this);
    }
    this.initData()
    document.addEventListener('mousedown', this.handleClickOutside, true);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside, true);
  }

  componentDidUpdate(prevProps) {
    const { selectFileList } = this.props;
    if (!_.isEqual(selectFileList, prevProps.selectFileList)) {
      const fileInfo = selectFileList[0]
      this.setState({
        selectFile: {
          libraryId: fileInfo ? fileInfo.libraryId : '',
          fileName: fileInfo ? fileInfo.fileName : '',
          modelKey: fileInfo ? fileInfo.modelKey : '',
          subckt: fileInfo ? fileInfo.subckt : '',
          nodes: fileInfo ? fileInfo.nodes : [],
          type: fileInfo ? fileInfo.type : '',
          notes: fileInfo ? fileInfo.notes : '',
        }
      })
    }
  }

  handleClickOutside = (e) => {
    const { target } = e;
    const PopoverRoot = document.getElementsByClassName('spice-node-select-Popover')[0];
    const selectRoot = document.getElementsByClassName('nodes-list-file-dropdown')[0];

    if (!PopoverRoot) {
      return;
    }

    if (!PopoverRoot || (PopoverRoot && !PopoverRoot.contains(target) && (!selectRoot || !selectRoot.contains(target)))) {
      this.closeNodesSelection();
    }
  }

  initData = () => {
    const { selectFileList } = this.props
    if (selectFileList.length) {
      const fileInfo = selectFileList[0]
      this.setState({
        selectFile: {
          libraryId: fileInfo ? fileInfo.libraryId : '',
          fileName: fileInfo ? fileInfo.fileName : '',
          modelKey: fileInfo ? fileInfo.modelKey : '',
          subckt: fileInfo ? fileInfo.subckt : '',
          nodes: fileInfo ? fileInfo.nodes : [],
          type: fileInfo ? fileInfo.type : '',
          notes: fileInfo ? fileInfo.notes : []
        }
      })
    }
  }

  closeNodesSelection = () => {
    this.setState({
      editNode: null,
      editType: null,
      searchValue: null,
      editComp: null
    })
  }

  selectNodesFile = (keyObj) => {
    const { selectFileList } = this.props;
    if (!keyObj) {
      this.setState({
        selectFile: {}
      })
      return;
    }
    const [libraryId, modelKey, subckt] = strDelimited(keyObj.key, "::");
    if (!libraryId || !modelKey) {
      this.setState({
        selectFile: {}
      })
      return;
    }
    const fileInfo = selectFileList.find(item => item.libraryId === libraryId);
    this.setState({
      selectFile: {
        libraryId,
        fileName: fileInfo ? fileInfo.fileName : '',
        modelKey,
        subckt,
        nodes: fileInfo ? fileInfo.nodes : [],
        type: fileInfo ? fileInfo.type : '',
        notes: fileInfo ? fileInfo.notes : []
      }
    })
  }

  openSelectNode = ({ e, port, value, type, currentItem, powerNet }) => {
    const { selectFile } = this.state
    const { selectFileList } = this.props
    const editNode = `${powerNet}-${type}-${port}`
    const libraryId = currentItem.libraryId || ""
    const modelKey = currentItem.modelKey || ""
    const subckt = currentItem.subckt || ""
    let _selectFile = selectFile || {}
    if (libraryId) {
      const file = selectFileList.find(item => item.libraryId === libraryId && item.modelKey === modelKey)
      _selectFile = {
        libraryId,
        fileName: file ? file.fileName : "",
        subckt,
        modelKey,
        type: file ? file.type : "",
        nodes: file ? file.nodes : [],
        notes: file ? file.notes : []
      };
    }
    let top = 300;
    if (e && e.target) {
      const rect = e.target.getBoundingClientRect();
      top = rect ? rect.top || 300 : 300;
    }
    this.setState({
      editNode,
      searchValue: value,
      selectFile: _selectFile,
      maxHeight: top - 30 > 300 ? top - 30 : 300
    })
  }

  stopPropagation = (e) => {
    e.stopPropagation();
  }

  selectPinNode = ({ node, selectFile, type, currentItem, powerNet }) => {
    const { ports } = this.props;
    const _ports = JSON.parse(JSON.stringify(ports));
    const groupIndex = _ports.findIndex(item => item.powerNet === powerNet);
    if (groupIndex === -1) return;
    const targetPorts = type === PMIC ? _ports[groupIndex].pmicPorts : _ports[groupIndex].icPorts;
    const index = targetPorts.findIndex(item => item.port === currentItem.port);
    if (index > -1) {
      const { subckt, libraryId, modelKey, fileName } = selectFile;
      targetPorts[index].node = targetPorts[index].node === node ? '' : node;
      targetPorts[index].fileName = fileName;
      targetPorts[index].libraryId = libraryId;
      targetPorts[index].modelKey = modelKey;
      targetPorts[index].subckt = subckt || '';
    }
    this.props.updatePorts(_ports);

    //find next
    const findNext = () => {
      for (let i = 0; i < _ports.length; i++) {
        const powerNetGroup = _ports[i];
        const powerNetKey = powerNetGroup.powerNet;
        for (let pmicPort of powerNetGroup.pmicPorts || []) {
          if (!pmicPort.node) return { port: pmicPort.port, type: PMIC, currentItem: pmicPort, powerNet: powerNetKey };
        }
        for (let icPort of powerNetGroup.icPorts || []) {
          if (!icPort.node) return { port: icPort.port, type: IC, currentItem: icPort, powerNet: powerNetKey };
        }
      }
      return null;
    }
    const next = findNext();
    if (next) {
      this.openSelectNode({
        e: null,
        port: next.port,
        value: next.currentItem.node || '',
        type: next.type,
        currentItem: next.currentItem,
        powerNet: next.powerNet
      });
    } else {
      this.closeNodesSelection();
    }
  };

  deleteSelectNode = (e, type, currentItem, powerNet) => {
    e && e.stopPropagation();
    const { ports } = this.props;
    const _ports = JSON.parse(JSON.stringify(ports));
    const groupIndex = _ports.findIndex(item => item.powerNet === powerNet);
    if (groupIndex === -1) return;
    const targetPorts = type === PMIC ? _ports[groupIndex].pmicPorts : _ports[groupIndex].icPorts;
    const index = targetPorts.findIndex(item => item.port === currentItem.port);
    if (index > -1) {
      targetPorts[index].node = '';
      targetPorts[index].fileName = '';
      targetPorts[index].libraryId = '';
      targetPorts[index].modelKey = '';
      targetPorts[index].subckt = '';
    }
    this.props.updatePorts(_ports);
  };

  isSameNode = (port, selectFile, node) => {
    return (
      port.libraryId === selectFile.libraryId &&
      port.modelKey === selectFile.modelKey &&
      port.node === node &&
      (selectFile.type !== SPICE || port.subckt === selectFile.subckt)
    );
  };

  getDisplayPortList = ({ currentItem, searchValue, selectFile, type, powerNet }) => {
    const { ports } = this.props;
    const { nodes = [], notes = [] } = selectFile;
    const nodeList = nodes.map(node => {
      let select = false;
      let currentSelect = false;
      if (this.isSameNode(currentItem, selectFile, node)) {
        currentSelect = true;
      }
      select = ports.some(group => {
        const { icPorts = [], pmicPorts = [], powerNet: _powerNet } = group;
        return (
          icPorts.some(p => {
            if (type === IC && powerNet === _powerNet && p.port === currentItem.port) {
              return false;
            }
            return this.isSameNode(p, selectFile, node);
          }) ||
          pmicPorts.some(p => {
            if (type === PMIC && powerNet === _powerNet && p.port === currentItem.port) {
              return false;
            }
            return this.isSameNode(p, selectFile, node);
          })
        );
      });
      const notePort = notes.find(item => item.port === node);
      let note = notePort ? notePort.info : node
      return { node, select, currentSelect, note };
    });

    const current = nodeList.filter(item => item.currentSelect);
    const matched = nodeList.filter(item => item.node.includes(searchValue) && !item.currentSelect && !item.select);
    const unused = nodeList.filter(item => !item.select && !item.currentSelect && !item.node.includes(searchValue));
    const used = nodeList.filter(item => item.select && !item.currentSelect);

    return [...current, ...matched, ...unused, ...used];
  }

  searchNode = (e) => {
    this.setState({
      searchValue: e.target.value
    })
  }

  cleanPort = () => {
    const { ports } = this.props;
    let _ports = JSON.parse(JSON.stringify(ports));
    _ports = _ports.map(group => {
      const icPorts = (group.icPorts || []).map(p => ({
        ...p,
        node: '',
        fileName: '',
        libraryId: '',
        modelKey: '',
        subckt: ''
      }));
      const pmicPorts = (group.pmicPorts || []).map(p => ({
        ...p,
        node: '',
        fileName: '',
        libraryId: '',
        modelKey: '',
        subckt: ''
      }));
      return {
        ...group,
        icPorts,
        pmicPorts
      };
    });
    this.props.updatePorts(_ports)
  }

  addPort = (powerNet, type) => {
    const { ports } = this.props;
    const _ports = (ports || []).map(group => {
      if (group.powerNet === powerNet) {
        if (type === IC) {
          const newICPorts = group.icPorts && group.icPorts.length > 0 ? [...group.icPorts] : [{ port: '1' }];
          newICPorts.push({ port: (newICPorts.length + 1).toString() });
          return { ...group, icPorts: newICPorts };
        } else if (type === PMIC) {
          const newPMICPorts = group.pmicPorts && group.pmicPorts.length > 0 ? [...group.pmicPorts] : [{ port: '1' }];
          newPMICPorts.push({ port: (newPMICPorts.length + 1).toString() });
          return { ...group, pmicPorts: newPMICPorts };
        }
      }
      return group;
    });
    this.props.updatePorts(_ports);
  }

  deletePort = (e, type, targetPort, powerNet) => {
    e && e.stopPropagation();
    const { ports } = this.props;
    const _ports = (ports || []).map(group => {
      if (group.powerNet === powerNet) {
        if (type === IC) {
          let icPorts = group.icPorts || [];
          if (icPorts.length <= 1) {
            return group;
          }
          let newICPorts = icPorts.filter(p => p.port !== targetPort);
          newICPorts = newICPorts.map((p, idx) => ({ ...p, port: (idx + 1).toString() }));
          return { ...group, icPorts: newICPorts };
        } else if (type === PMIC) {
          let pmicPorts = group.pmicPorts || [];
          if (pmicPorts.length <= 1) {
            return group;
          }
          let newPMICPorts = pmicPorts.filter(p => p.port !== targetPort);
          newPMICPorts = newPMICPorts.map((p, idx) => ({ ...p, port: (idx + 1).toString() }));
          return { ...group, pmicPorts: newPMICPorts };
        }
      }
      return group;
    });
    this.props.updatePorts(_ports);
  }

  nodeSelectRender = ({ port, type, currentItem, powerNet }) => {
    const { searchValue, selectFile = {}, maxHeight } = this.state;
    const { selectFileList } = this.props;
    const nodeList = this.getDisplayPortList({ currentItem, searchValue, selectFile, type, powerNet });
    const { libraryId, subckt, fileName, modelKey } = selectFile;
    return (
      <div className='nodes-content' style={{ maxHeight, maxWidth: 400 }}>
        <div className='nodes-content-header'>
          <span className='nodes-content-header-span'> {`Port ${port}`}</span>
        </div>
        <div className='node-content-close' onClick={() => this.closeNodesSelection()}>
          <CloseOutlined className='node-content-close-icon' />
        </div>
        <div className="node-list-body-with-search">
          <div className="node-list-body-search-wrapper">
            <Select
              placeholder={`Select File/Subckt`}
              className='nodes-list-file-select'
              labelInValue
              value={{
                key: libraryId ? subckt ? `${libraryId}::${modelKey}::${subckt}` : `${libraryId}::${modelKey}` : "",
                label: subckt ? `${fileName}::${subckt}` : fileName || ""
              }}
              popupClassName='nodes-list-file-dropdown'
              popupMatchSelectWidth={false}
              onChange={option => option && this.selectNodesFile({ label: option.label, key: option.value })}
              options={selectFileList.map(item => ({
                value: item.subckt ? `${item.libraryId}::${item.modelKey}::${item.subckt}` : `${item.libraryId}::${item.modelKey}`,
                label: item.subckt ? `${item.fileName}::${item.subckt}` : item.fileName || "",
                title: item.subckt ? `${item.fileName}::${item.subckt}` : item.fileName || "",
                className: "spice-nodes-content-file"
              }))}
            />
            <Input
              placeholder={`Search`}
              allowClear
              suffix={!searchValue ? <SearchOutlined style={{ color: 'rgba(0, 0, 0, .25)' }} /> : null}
              value={searchValue}
              onChange={(e) => this.searchNode(e)}
            />
            <ul className='node-list-ul' style={{ maxHeight: maxHeight - 100 }}>
              {nodeList.map(item =>
                <li
                  key={item.node}
                  title={item.node}
                  className={item.currentSelect ? 'current-pin-selected-node-li' : (item.select ? 'node-li-selected' : '')}
                  onClick={() => !item.select ? this.selectPinNode({ node: item.node, selectFile, type, currentItem, powerNet }) : null}
                >
                  {item.note || item.node}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    );
  }

  pinLine = () => {
    return <div className='spice-pin-line'></div>
  }

  pinCircle = () => {
    return <div className='spice-pin-circle'></div>
  }

  getPortsDisplay = ({ item, editNode, type, powerNet }) => {
    const [editPowerNet, editType, editPort] = strDelimited(editNode, '-')
    const { port = '', node = '' } = item || {}
    const key = `${powerNet}-${type}-${port}`
    const pinNode = () => {
      return <div className={type === PMIC ? 'spice-pin-die-value-box' : 'spice-pin-value-box'}>
        {editNode && editPowerNet === powerNet && editType === type && editPort === port ? <Popover
          classNames={{ root: 'spice-node-select-Popover' }}
          content={this.nodeSelectRender({
            port: port,
            type,
            currentItem: item,
            powerNet
          })}
          title=""
          trigger="click"
          open={true}
          placement={"top"}
        >
          <Input
            className='spice-pin-input pre-layout-spice-node'
            placeholder={'Node'}
            value={node}
            id={port}
            onClick={(e) => this.openSelectNode({
              e,
              port: port,
              value: node,
              type,
              currentItem: item,
              powerNet
            })}
          />
        </Popover> :
          node ?
            <Tooltip
              classNames={{ root: "aurora-tooltip" }}
              onClick={(e) => this.stopPropagation(e)}
              title={<Fragment>{item && item.fileName && <div>FileName: {item.fileName}</div>}<div>Port: {node}</div></Fragment>}>
              <div className='spice-pin-input pre-layout-spice-node' id={port} title={item.node}
                onClick={(e) => this.openSelectNode({
                  e,
                  port: port,
                  value: node,
                  type,
                  currentItem: item,
                  powerNet
                })}
              >
                <span>{node}</span>
                <CloseCircleFilled
                  className='spice-pin-node-delete-icon'
                  onClick={(e) => { this.deleteSelectNode(e, type, item, powerNet) }}
                />
              </div>
            </Tooltip>
            :
            <Input
              className='spice-pin-input pre-layout-spice-node'
              placeholder={'Node'}
              value={node}
              id={port}
              onClick={(e) => this.openSelectNode({
                e,
                port: port,
                value: node,
                type,
                currentItem: item,
                powerNet
              })}
            />}
      </div>
    }

    const pinPort = () => {
      return <Fragment>
        <div className={type === PMIC ? 'spice-pin-die-box' : 'spice-pin-box'}
          title={`Port ${port}`}
        >
          {`Port ${port}`}
          <CloseCircleFilled
            className='spice-port-delete-icon'
            onClick={(e) => { this.deletePort(e, type, port, powerNet) }}
            style={type === PMIC ? { right: 72 } : { left: 72 }}
          />
        </div>
      </Fragment>
    }

    return (
      <div key={key} className='spice-total-pin-box' style={{ width: 224, position: 'relative' }}>
        {port ?
          type === PMIC ? <Fragment>
            {pinNode()}
            {pinPort()}
            {this.pinLine()}
            {this.pinCircle()}
          </Fragment> : <Fragment>
            {this.pinCircle()}
            {this.pinLine()}
            {pinPort()}
            {pinNode()}
          </Fragment> : null}
      </div>
    )
  }

  titleContent = () => {
    return <div className="spice-pin-connect-node-title" style={{ paddingLeft: 20 }}>
      <span className='spice-pin-left-title cascade-spice-pin-left-title'>PMIC</span>
      <span className='spice-pin-right-title cascade-spice-pin-right-title'>IC</span>
      <DeleteOutlined
        title="Clean Nodes"
        onClick={() => this.cleanPort()}
      />
    </div>
  }

  render() {
    const { editNode } = this.state;
    const { ports } = this.props
    return (
      <Fragment>
        <div className='spice-netlist-model-content'>
          <div className='spice-connect-content'>
            <ul className='spice-pin-list-ul'>
              {this.titleContent()}
              {ports.map((item, index) => {
                const { icPorts = [], pmicPorts = [], powerNet } = item;
                const maxLength = Math.max(icPorts.length, pmicPorts.length)
                return <div className={`spice-pin-connect-node-item`} key={index} style={{ height: 32 * maxLength + 30, paddingRight: 10 }}>
                  <div className='spice-pin-list-li-left'>
                    {pmicPorts.map(item => this.getPortsDisplay({ item, editNode, type: PMIC, powerNet }))}
                  </div>
                  {/* net box */}
                  <div
                    className={index === 0 ? `spice-box spice-box-top` : (index === (ports.length - 1) ? `spice-box spice-box-bottom` : `spice-box`)}
                  >
                    <span className='spice-box-net-text'>{powerNet}</span>
                    <span className='spice-box-add-port'>
                      <span className='add-pmic-port' onClick={() => this.addPort(powerNet, PMIC)}>Add PMIC Port</span>
                      <span className='add-ic-port' onClick={() => this.addPort(powerNet, IC)}>Add IC Port</span>
                    </span>
                  </div>
                  <div className='spice-pin-list-li-right'>
                    {icPorts.map(item => this.getPortsDisplay({ item, editNode, type: IC, powerNet }))}
                  </div>
                </div>
              })}
            </ul>
          </div>
        </div>
      </Fragment >
    );
  }
}

export default Model;